module.exports = __webpack_public_path__ + "static/media/m-1-05.a3d1a101.svg";